import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DragulaService } from 'ng2-dragula';

import { CosyDynaeditorControllerService } from 'src/app/service/controller/cosy-dynaeditor-controller.service';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';

//import * as _ from 'lodash';
import cloneDeep from 'lodash-es/cloneDeep';
import { IEDisplayProperties, IELabel, InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';

import { Guid } from "guid-typescript";
import { Attribute } from 'src/app/model/asd/asd-properties/asd-attribute';
import { CosyAppStateDataControllerService } from 'src/app/service/controller/cosy-app-state-data-controller.service';
@Component({
  selector: 'app-cosy-dynaeditor-wizard',
  templateUrl: './cosy-dynaeditor-wizard.component.html',
  styleUrls: ['../cosy-dynaeditor.component.css','./cosy-dynaeditor-wizard.component.css']
})
export class CosyDynaeditorWizardComponent implements OnInit {


  @Input() dynaEditorElement:InterfaceElement;
  @Input() dynaItem:any;
  @Output() dynaItemChange = new EventEmitter();
  @Output() saveDEData = new EventEmitter();
 
  public guid: Guid;
  public ie: InterfaceElement;
  public ieNew : InterfaceElement;
  public unAssignedElements: any[] = [];
  public wizardCode: string = 'W-';
  public showGroupItemDetail: boolean;
  public isVisible: boolean;
  public isHeaderVisible: boolean = false;
  public dynaGroupItemForm: any;
  public groups: any[]=[];
  public wizardIE: InterfaceElement;
  public groupAssignedSpace: string = "col-md-12";
  public displayOrders: number[] = [];
  
  constructor(private uxControllerService: UXControllerService,
    private cosyDynaeditorControllerService: CosyDynaeditorControllerService,
    private cosyAppStateDataControllerService : CosyAppStateDataControllerService,
    private formBuilder: FormBuilder,
    private dragulaService: DragulaService) {
 
      dragulaService.drop("entity-items").subscribe(value => { 
          if(value.target.id == 'UnAssignedElements'){
            document.getElementById('W-' + value.el.id).style.visibility = 'hidden';
          } else {
            
            for(let group of this.groups){
              if(value.target.id == group.InterfaceElementID){
                document.getElementById('W-' + value.el.id).style.visibility = 'visible';
              }
            }
           
          } 
        this.cosyDynaeditorControllerService.dynaEditorProcessing(value, 'drag', this.dynaEditorElement['ie'], this.uxControllerService.cosyFormInitProperties);
      });
      
    }

  ngOnInit() {
   
    this.ie = this.dynaEditorElement['ie'];
    this.loadDynaEditorData();
  }
  changeOrder(order){
    let ID =   this.dynaGroupItemForm.value['ID'];
    let value = order.value; 
  }
  
  createNewGroup(){
    this.guid = Guid.create();
    let groupItem: InterfaceElement = new InterfaceElement();
    groupItem.InterfaceElementID = this.guid.toString();
    groupItem.DisplayProperties = new IEDisplayProperties();
    groupItem.Attributes = new Attribute();
    groupItem.Label = new IELabel();
    groupItem.Label.DisplayName = "";
    groupItem.DisplayProperties.DisplayName = "";
    groupItem.DisplayProperties.DisplaySrcKey = "Label";
    groupItem.DisplayProperties.IsDisplayOnUI = true;
    
    groupItem.Attributes.Visible = true;
    groupItem.TypeDID = InterfaceElementTypes.Group;
    this.editdynaEditorItem(groupItem);
  }

  updateFormValues(updatedDynaForm, actionType){
    this.saveDEData.emit(updatedDynaForm);
    this.showGroupItemDetail = false;
    this.groupAssignedSpaces(this.dynaEditorElement['ie']);
    this.groups = this.ie.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups).InterfaceElements;
    this.groups = this.groups.sort((a,b)=> a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
    this.displayOrders = this.displayOrders.sort();
  }

  loadDynaGroupItemEditForm(item: any) {
    
    let head = this.ie.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups);
    this.isHeaderVisible = false;
    this.isVisible = true;
    let groupID = "";
    if(item.TypeDID == InterfaceElementTypes.Group){
      groupID = head.InterfaceElementID;
      this.isHeaderVisible = true;
    }
   
    if(item.DisplayProperties== null){
      item = this.cosyAppStateDataControllerService.setDisplayPropsOfIE(item, null);
    }
      this.dynaGroupItemForm = this.formBuilder.group({
        ID: [item.InterfaceElementID],
        id:[item.InterfaceElementID],
        displayName: [item.DisplayProperties.DisplayName],
        name: [item.Name],
        visible: [item.Attributes.Visible],
        groupID : groupID,
        displayOrder : [item.Attributes.DisplayOrder],
        
      });
    
  }


  editdynaEditorItem(dynaEditItem: any) {
    this.dynaItem = dynaEditItem;
    this.dynaItemChange.emit(this.dynaItem);
    this.loadDynaGroupItemEditForm(dynaEditItem);
    this.showGroupItemDetail = true;
  }

  groupAssignedSpaces(interfaceElement: InterfaceElement){
    this.unAssignedElements = [];
    this.displayOrders = [];
     
    this.groups = interfaceElement.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups).InterfaceElements;
    this.groups = this.groups.sort((a,b)=> a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
      for(let gie of this.groups){
        this.displayOrders.push(gie.Attributes.DisplayOrder);
      }
      for(let i of interfaceElement.InterfaceElements){
        if(i.TypeDID!= InterfaceElementTypes.Groups){
          this.unAssignedElements.push(i);
        }
      }
      if(this.groups.length == 2) this.groupAssignedSpace = "col-md-6";
      if(this.groups.length>=3) this.groupAssignedSpace = "col-md-4";
  } 
  
  loadDynaEditorData(){
    
    let ieIndex: number = -1;
    this.ieNew = new InterfaceElement();
    
    this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument =  cloneDeep(this.cosyDynaeditorControllerService.processedCASD)
    ieIndex = this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument.InterfaceElements.map(function (d) {
      return d['InterfaceElementID'];
    }).indexOf(this.ie.InterfaceElementID);
    this.groupAssignedSpaces(this.ie);
 
  }
}
